import { QuoteElement } from "../../lib/quote-element.js";
import { SelectedState } from "../../lib/selected-state.js";
import { formatCurrency } from "../../lib/utils.js";
import { css, html } from "lit";
import { property, customElement } from "lit/decorators.js";
import "../../common/offer-add-button.js";
import { when } from "lit/directives/when.js";
import { classMap } from "lit/directives/class-map.js";
import "../../common/offer-accordion-header.js";
import "../../common/offer-radio-header.js";
import packageOfferStyles from "../../lib/package-offer-styles.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let TravelInsurancePackage = class extends QuoteElement {
  constructor() {
    super("travel");
    this.recommended = false;
  }
  /**
   * @ignore
   */
  get policyAttributes() {
    return {
      trip_start_date: this.tripStartDate,
      trip_end_date: this.tripEndDate,
      origin: {
        state: this.originState,
        country: this.originCountry
      },
      destination_countries: this.destinationCountries,
      coverage_type: this.coverageType,
      trip_cost: this.tripCost
    };
  }
  toggleOfferSelection() {
    if (this.selectedState === SelectedState.ACCEPTED) {
      this.selectedState = SelectedState.UNKNOWN;
      this.triggerOfferStateChangeEvent();
    } else {
      this.accept();
    }
  }
  render() {
    return this.quoteController.render({
      complete: () => {
        var _a, _b, _c, _d, _e, _f;
        return html`
        <div id="offer-display" class=${classMap({ "selected": this.selectedState === SelectedState.ACCEPTED })}>
          ${when(this.recommended, () => html`<div id="offer-tag">Most Popular</div>`)}
          <offer-radio-header @change=${this.toggleOfferSelection} .checked=${this.selectedState === SelectedState.ACCEPTED} .quote=${this.quote}>
            ${((_a = this.quote) == null ? void 0 : _a.total) ? formatCurrency((_b = this.quote) == null ? void 0 : _b.total, (_c = this.quote) == null ? void 0 : _c.currency) : ""}
          </offer-radio-header>
          <offer-accordion-header .showRecommendedTag=${this.recommended} @change=${this.toggleOfferSelection} .checked=${this.selectedState === SelectedState.ACCEPTED}  .quote=${this.quote}>
            ${((_d = this.quote) == null ? void 0 : _d.total) ? formatCurrency((_e = this.quote) == null ? void 0 : _e.total, (_f = this.quote) == null ? void 0 : _f.currency) : ""}
          </offer-accordion-header>
          <promotional-description  .quote=${this.quote}></promotional-description>
          <section id="offer-content">
            <peril-list .quote=${this.quote} .declined=${this.selectedState === SelectedState.DECLINED}></peril-list>
          </section>
        </div>
    `;
      }
    });
  }
};
TravelInsurancePackage.styles = [
  QuoteElement.styles,
  packageOfferStyles,
  css`
      :host {
        margin: unset;
      }

      #offer-display {
        gap: 5px;
      }

      @media (max-width: 700px) {
        #offer-display {
          padding: 16px;
        }
    
        #offer-display offer-header { 
          display: none;
        }
    
        #offer-display offer-radio-header { 
          display: none;
        }
    
        #offer-display offer-accordion-header, 
        #offer-display.selected offer-accordion-header  {
          display: block;
        }
    
        #offer-display section#actions {
          display: none;
        }
    
        #offer-display #offer-content {
          display: none;
        }
    
        #offer-tag {
          display: none;
        }
      }
    `
];
__decorateClass([
  property()
], TravelInsurancePackage.prototype, "coverageType", 2);
__decorateClass([
  property()
], TravelInsurancePackage.prototype, "tripStartDate", 2);
__decorateClass([
  property()
], TravelInsurancePackage.prototype, "tripEndDate", 2);
__decorateClass([
  property({ type: Array })
], TravelInsurancePackage.prototype, "destinationCountries", 2);
__decorateClass([
  property({ type: Number })
], TravelInsurancePackage.prototype, "tripCost", 2);
__decorateClass([
  property()
], TravelInsurancePackage.prototype, "originState", 2);
__decorateClass([
  property()
], TravelInsurancePackage.prototype, "originCountry", 2);
__decorateClass([
  property({ type: Boolean })
], TravelInsurancePackage.prototype, "recommended", 2);
TravelInsurancePackage = __decorateClass([
  customElement("travel-insurance-package")
], TravelInsurancePackage);
export {
  TravelInsurancePackage
};
